import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  primaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    marginTop: theme.spacing(1),
    width: '100%',
  },
  sellerTypeSection: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    pointerEvents: 'none',
    cursor: 'not-allowed',
  },
  choiceBox: {
    width: '100%',
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.textField.light}`,
    padding: theme.spacing(2, 3),
  },
  choiceBoxText: {
    marginLeft: theme.spacing(4),
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
  },
  selectCurrencySection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
  },
  selectCurrencyHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraText.primary,
  },
  selectCurrencySelector: {
    marginBottom: theme.spacing(3),
  },
}))
